import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
const ButtonsListContainer = styled.div`
  label: JMT-General-ButtonsListContainer;
  position: absolute;
  z-index: 100;
  width: 100px;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #1c375f2e;
  display: ${p => p.isVisible ? 'block' : 'none'};
`;
const ButtonsList = styled.div`
  label: JMT-General-ButtonsList;
  display: flex;
  flex-direction: column;
`;
const ButtonDropDownWrapper = styled.div`
  label: JMT-General-ButtonDropDownWrapper;
  position: relative;
  width: 100%;
`;
export const Dropdown = ({
  isVisible,
  children
}) => React.createElement(ButtonDropDownWrapper, null, React.createElement(ButtonsListContainer, {
  isVisible: isVisible
}, React.createElement(ButtonsList, null, children)));
Dropdown.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};